/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostWiseSummary {
    getFixupPrototypeFunction() { return CostWiseSummary.fixupPrototype; }

    static newInstance(model: Partial<CostWiseSummary>): CostWiseSummary {
        let obj = Object.assign(new CostWiseSummary(), model);
        CostWiseSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostWiseSummary>): CostWiseSummary {
        if (!model) return null;
        return CostWiseSummary.newInstance(<CostWiseSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostWiseSummary) {
        if (!obj) return;

        models.CostWiseSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostWiseSummary): boolean {
        Object.setPrototypeOf(obj, CostWiseSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_cost === undefined) {
            this.total_cost = 0;
        }
        if (this.azure === undefined) {
            this.azure = 0;
        }
        if (this.AWS === undefined) {
            this.AWS = 0;
        }
        if (this.GCP === undefined) {
            this.GCP = 0;
        }
    }

    /**
     * Total cost saved
     */
    total_cost: number;

    /**
     * Cost saved for Azure based on recommendation
     */
    azure: number;

    /**
     * Cost saved for AWS based on recommendation
     */
    AWS: number;

    /**
     * Cost saved for GCP based on recommendation
     */
    GCP: number;

}
